import { combineReducers } from '@reduxjs/toolkit';

import ui from './ui';
import generalSlice from './general';
import { persistedBatchReducer } from './batch';

const reducer = combineReducers({
  ui: ui.reducer,
  general: generalSlice.reducer,
  batch: persistedBatchReducer,
});

export default reducer;
